export const getPipeline = (pipelines = [], pipelineId) => {
  if (pipelineId) {
    return pipelines.find((pipeline) => String(pipeline.id) === String(pipelineId));
  }

  // Match the summary's selection when multiple pipelines are marked as default.
  const defaultPipeline = pipelines
    .filter((pipeline) => pipeline.default)
    .sort((a, b) => a.id - b.id)[0];
  // The v1 pipeline list also returns an existing fallback when no default exists.
  return defaultPipeline ?? pipelines[0];
};

export const getContactPipeline = (pipelines, pipelineStatus, requestedPipelineId) => {
  const contactPipelineId = pipelineStatus?.pipeline?.id;
  if (
    requestedPipelineId &&
    contactPipelineId &&
    String(requestedPipelineId) !== String(contactPipelineId)
  ) {
    return undefined;
  }

  // An existing stage without its pipeline cannot safely offer editing options.
  if (pipelineStatus?.stage?.id && !contactPipelineId) return undefined;

  return getPipeline(pipelines, requestedPipelineId || contactPipelineId);
};
